@if (initialized) {
    <div class="mb-6 flex justify-between analyze-container">
        <p-selectButton [allowEmpty]="false" [options]="stateOptions" (onChange)="toggleState($event.value)" [ngModel]="analyzeState" />
        <div class="calendar-container fluid">
            <app-date-range-selector
                data-testid="analyze-date-range"
                [userDateFormat]="userDateFormat"
                [firstDayOfWeek]="firstDayOfWeek"
                [licenseStatePro]="licenseStatePro"
                [dateRange]="filters.dateRange"
                [dateRangeOption]="filters.dateRangeOption"
                (onDateChanged)="onDateChanged($event)"
            />
        </div>
    </div>

    <div class="card">
        <div class="">
            <div class="flex flex-wrap items-center filter-box">
                <h5>{{ "report_filter" | translate }}</h5>

                @if (currentUser?.hasPermissionStr("ACTIVITY_READ_TEAM") && showMultiSelect()) {
                    <div [tooltipDisabled]="licenseStatePro" pTooltip="{{ 'activities_filteralluser_proFeature' | translate }}" tooltipPosition="top">
                        <p-multiSelect
                            id="multiSelect"
                            [options]="teamOptions"
                            [group]="true"
                            [(ngModel)]="filters.selectedTeamFilter"
                            (ngModelChange)="onFilterChange('selectedTeamFilter', $event)"
                            placeholder="{{ 'standard_team' | translate }}"
                            [panelStyle]="{ 'min-width': '300px' }"
                            [maxSelectedLabels]="1"
                            selectedItemsLabel="{0} {{ 'standard_items_selected' | translate }}"
                            scrollHeight="250px"
                            [disabled]="!licenseStatePro"
                        >
                            <ng-template let-group pTemplate="group">
                                @if (group.items.length > 0) {
                                    <span class="group-label">{{ group.label }}</span>
                                }
                            </ng-template>
                        </p-multiSelect>
                    </div>
                }

                @if (layers.length > 0) {
                    <p-multiSelect
                        data-testid="analyze-layer-filter-1"
                        [options]="layer1FilterOptions"
                        [(ngModel)]="filters.selectedLayer1Filter"
                        (ngModelChange)="onFilterChange('selectedLayer1Filter', $event)"
                        [panelStyle]="{ 'min-width': '300px' }"
                        placeholder="{{ getLayerPlaceholder(1) }}"
                        optionLabel="name"
                        [maxSelectedLabels]="1"
                        selectedItemsLabel="{0} {{ getLayerPlaceholder(1) }}"
                        (onChange)="onLayer1SlChange($event)"
                        class="multiselect-width-25"
                    />
                    @if (layers[1]?.visible === true) {
                        <p-multiSelect
                            data-testid="analyze-layer-filter-2"
                            [options]="layer2FilterOptions"
                            [(ngModel)]="filters.selectedLayer2Filter"
                            (ngModelChange)="onFilterChange('selectedLayer2Filter', $event)"
                            [panelStyle]="{ 'min-width': '300px' }"
                            placeholder="{{ getLayerPlaceholder(2) }}"
                            optionLabel="name"
                            [maxSelectedLabels]="1"
                            selectedItemsLabel="{0} {{ getLayerPlaceholder(2) }}"
                            (onChange)="onLayer2SlChange()"
                            class="multiselect-width-25"
                        />
                    }
                    @if (layers[2]?.visible === true) {
                        <p-multiSelect
                            data-testid="analyze-layer-filter-3"
                            [options]="layer3FilterOptions"
                            [(ngModel)]="filters.selectedLayer3Filter"
                            (ngModelChange)="onFilterChange('selectedLayer3Filter', $event)"
                            [panelStyle]="{ 'min-width': '300px' }"
                            placeholder="{{ getLayerPlaceholder(3) }}"
                            optionLabel="name"
                            [maxSelectedLabels]="1"
                            selectedItemsLabel="{0} {{ getLayerPlaceholder(3) }}"
                            class="multiselect-width-25"
                        />
                    }

                    <div class="filter-badge-wrapper">
                        <button data-testid="analyze-more-filters" type="button" class="p-button-text" pButton severity="secondary" (click)="op.toggle($event)">
                            {{ "activities_more_filters" | translate }}
                            <i class="pi pi-chevron-down"></i>
                        </button>
                        @if (filters.isBilled !== undefined || filters.isNoteAvailable !== undefined || filters.filterDescription !== "") {
                            <span class="filter-count-badge">
                                {{
                                    (filters.filterDescription !== "" || filters.isNoteAvailable !== undefined ? 1 : 0) +
                                        (filters.isBilled !== undefined ? 1 : 0)
                                }}
                            </span>
                        }
                    </div>
                    <div style="margin-left: auto; margin-bottom: 0 !important">
                        @if (isFilterActive()) {
                            <button data-testid="analyze-clear-filters" type="submit" pButton class="p-button-outlined mr-2" (click)="clearFilter()">
                                <i class="pi pi-filter-slash"></i>
                            </button>
                        }
                        <button
                            data-testid="analyze-apply-filters"
                            class="p-button"
                            pButton
                            type="button"
                            style="margin-left: auto; margin-bottom: 0 !important"
                            (click)="filterButtonClicked()"
                        >
                            {{ "activities_filterapply" | translate }}
                        </button>
                    </div>
                }
            </div>
        </div>
    </div>

    @if (analyzeState === "overview" && initialized) {
        <app-analyze-overview
            [allUsers]="usersFilterOptions"
            [filters]="appliedFilters"
            [filterSubmit$]="eventsSubject.asObservable()"
            (onHasDataChanged)="onHasDataChanged($event)"
        />
    } @else if (analyzeState === "detail" && initialized) {
        <app-analyze-detail
            [allUsers]="usersFilterOptions"
            [filters]="appliedFilters"
            [filterSubmit$]="eventsSubject.asObservable()"
            (onHasDataChanged)="onHasDataChanged($event)"
        />
    }

    <p-popover #op>
        <div>
            <!-- (onChange)="isNoteAvailableChanged($event) -->
            <div class="flex flex-col gap-2">
                <p class="font-semibold mb-2!">{{ "activities_filter_note" | translate }}</p>
                <div class="flex items-center">
                    <p-radioButton name="noteFilter" [value]="undefined" [(ngModel)]="filters.isNoteAvailable" inputId="note_all" />
                    <label for="note_all" class="ml-2">{{ "standard_all" | translate }}</label>
                </div>

                <div class="flex items-center">
                    <p-radioButton name="noteFilter" [value]="true" [(ngModel)]="filters.isNoteAvailable" inputId="note_filled" />
                    <label for="note_filled" class="ml-2">{{ "activities_filter_note_filled" | translate }}</label>
                </div>
                <input
                    data-testid="analyze-note-filter"
                    name="noteTextFilter"
                    class="ml-6"
                    type="text"
                    pInputText
                    [(ngModel)]="filters.filterDescription"
                    [disabled]="filterDescriptionDisabled"
                    placeholder="{{ 'activities_filter_note_placeholder' | translate }}"
                    (ngModelChange)="
                        onFilterChange('filterDescription', $event);
                        filters.filterDescription === '' ? (filters.isNoteAvailable = undefined) : (filters.isNoteAvailable = true)
                    "
                />

                <div class="flex items-center">
                    <p-radioButton name="noteFilter" [value]="false" [(ngModel)]="filters.isNoteAvailable" inputId="note_empty" />
                    <label for="note_empty" class="ml-2">{{ "activities_filter_note_empty" | translate }}</label>
                </div>
            </div>

            @if (currentUser?.hasPermissionStr("ACTIVITY_READ_TEAM")) {
                <div class="flex flex-col gap-2 mt-8" pTooltip="{{ (!licenseStatePro ? 'tooltip_pro_filter_billed' : '') | translate }}">
                    <p class="font-semibold mb-2!">{{ "standard_status" | translate }}</p>
                    <div class="flex items-center">
                        <p-radioButton
                            [disabled]="!licenseStatePro"
                            name="billedFilter"
                            [value]="undefined"
                            [(ngModel)]="filters.isBilled"
                            (ngModelChange)="onFilterChange('isBilled', $event)"
                            inputId="status_all"
                        />
                        <label for="status_all" class="ml-2">{{ "standard_all" | translate }}</label>
                    </div>

                    <div class="flex items-center">
                        <p-radioButton
                            [disabled]="!licenseStatePro"
                            name="billedFilter"
                            [value]="true"
                            [(ngModel)]="filters.isBilled"
                            (ngModelChange)="onFilterChange('isBilled', $event)"
                            inputId="status_billed"
                        />
                        <label for="status_billed" class="ml-2">{{ "activities_billed" | translate }}</label>
                    </div>

                    <div class="flex items-center">
                        <p-radioButton
                            [disabled]="!licenseStatePro"
                            name="billedFilter"
                            [value]="false"
                            [(ngModel)]="filters.isBilled"
                            (ngModelChange)="onFilterChange('isBilled', $event)"
                            inputId="status_not_billed"
                        />
                        <label for="status_not_billed" class="ml-2">{{ "activities_not_billed" | translate }}</label>
                    </div>
                </div>
            }
        </div>
    </p-popover>
}
